module.exports = __webpack_public_path__ + "img/lotterybg.8c5273fe.png";